//
//
//
//
//
//
//
//
//
//

import { faUmbrellaBeach, faTags, faGlobeAsia } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'Perks',
  components: {
    HomeBenefits: () => import('@/components/home-page/HomeBenefits.vue'),
  },
  data() {
    return {
      perks: [
        {
          icon: faUmbrellaBeach,
          color: 'aqua',
          heading: this.$t('contributor.intro.benefits.income_heading'),
          text: this.$t('contributor.intro.benefits.income_text'),
        },
        {
          icon: faTags,
          color: 'pink',
          heading: this.$t('contributor.intro.benefits.pricing_heading'),
          text: this.$t('contributor.intro.benefits.pricing_text'),
        },
        {
          icon: faGlobeAsia,
          color: 'blue',
          heading: this.$t('contributor.intro.benefits.global_heading'),
          text: this.$t('contributor.intro.benefits.global_text'),
        },
      ],
    };
  },
};
